<template>
  <v-snackbar
    v-if="open"
    v-model="open"
    top
    center
    :timeout="2000">
    {{ response }}
    <v-btn
      dark
      @click="setNotification">
      Kapat
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'FreeNotification',
  data: () => ({
    open: false,
    response: '',
  }),
  methods: {
    setNotification($event, d) {
      this.open = !this.open;
      this.response = d;
    },
  },
  events: {
    'set:notification': 'setNotification',
  },
};
</script>
